import "core-js/modules/es.function.name.js";
import { afterFrame } from '@elastic/apm-rum-core';
import Vue from 'vue';
import { useAPM } from '~/composables/_next/useAPM';

// https://github.com/elastic/apm-agent-rum-js/blob/%40elastic/apm-rum-vue%401.3.2/packages/rum-vue/src/route-hooks.js
function routeHooks(router, apm) {
  var transaction;
  router.beforeEach(function (to, from, next) {
    var matched = to.matched || [];
    var path = to.path;
    /**
     * Get the last matched route record which acts as stack when
     * route changes are pushed and popped out of the stack
     *
     * Also account for the slug pattern on the routes, to.path always
     * resolves the current slug param, but we need need to
     * use the slug pattern for the transaction name
     */
    if (matched.length > 0) {
      path = matched[matched.length - 1].path || path;
    }
    transaction = apm.startTransaction(path, 'route-change', {
      managed: true,
      canReuse: true
    });
    next();
  });
  router.afterEach(function () {
    afterFrame(function () {
      return transaction && transaction.detectFinish();
    });
  });
  /**
   * handle when the navigation is cancelled in `beforeEach` hook of components
   * where `next(error)` is called
   */
  router.onError(function () {
    transaction && transaction.end();
  });
}

// https://github.com/elastic/apm-agent-rum-js/blob/%40elastic/apm-rum-vue%401.3.2/packages/rum-vue/src/error-handler.js
function getErrorHandler(Vue, apm) {
  var _this = this;
  /**
   * If the user already installed a global error handler
   * we should call them after capturing it internally
   */
  var previousErrorHandler = Vue.config.errorHandler;
  return function (error, vm, info) {
    if (vm && vm.$options) {
      var options = vm.$options;
      var component;
      if (vm.$root === vm) {
        component = 'Root';
      } else {
        component = options.name || options._componentTag || 'Anonymous';
      }
      error.component = component;
      error.file = options.__file || '';
    }

    /**
     * Lifecycle hook the error was thrown if available
     */
    if (info) {
      error.lifecycleHook = info;
    }
    apm.captureError(error);
    if (typeof previousErrorHandler === 'function') {
      previousErrorHandler.call(_this, error, vm, info);
    }
    /**
     * Logs the error to browser console similar
     * to original Vue logError
     */
    console.error(error);
  };
}
export default defineNuxtPlugin(function () {
  var _useAPM = useAPM(),
    loadAPM = _useAPM.loadAPM;
  var apm = loadAPM();
  if (!apm.isActive()) {
    return;
  }
  var router = useRouter();
  if (router) {
    routeHooks(router, apm);
  }
  Vue.config.errorHandler = getErrorHandler(Vue, apm);
});